/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import rtkRequestStatusCodes from "../../lib/const/rtkRequestStatusCodes";
import { getBalanceRoute } from "../../lib/routes/balance";

const initialState = {
  balance: null,
  balanceLoading: rtkRequestStatusCodes.idle,
};

const fetchBalance = createAsyncThunk("balance/fetchBalance", async (agreementId) => {
  const { data } = await axios(getBalanceRoute(agreementId));
  return data;
});

const slice = createSlice({
  name: "balance",
  initialState,
  reducers: {},
  extraReducers: {
    [fetchBalance.fulfilled]: (state, { payload }) => {
      state.balance = payload;
      state.balanceLoading = rtkRequestStatusCodes.fulfilled;
    },
  },
});

const { actions, reducer } = slice;
export { actions, fetchBalance };
export default reducer;
